import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\DossierNumbering\GetDossierNumberingListController::__invoke
* @see app/Http/Controllers/DossierNumbering/GetDossierNumberingListController.php
* @route '/api/dossier-numbering'
*/
const GetDossierNumberingListController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetDossierNumberingListController.url(options),
    method: 'get',
})

GetDossierNumberingListController.definition = {
    methods: ["get","head"],
    url: '/api/dossier-numbering',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\DossierNumbering\GetDossierNumberingListController::__invoke
* @see app/Http/Controllers/DossierNumbering/GetDossierNumberingListController.php
* @route '/api/dossier-numbering'
*/
GetDossierNumberingListController.url = (options?: RouteQueryOptions) => {
    return GetDossierNumberingListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\DossierNumbering\GetDossierNumberingListController::__invoke
* @see app/Http/Controllers/DossierNumbering/GetDossierNumberingListController.php
* @route '/api/dossier-numbering'
*/
GetDossierNumberingListController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetDossierNumberingListController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\DossierNumbering\GetDossierNumberingListController::__invoke
* @see app/Http/Controllers/DossierNumbering/GetDossierNumberingListController.php
* @route '/api/dossier-numbering'
*/
GetDossierNumberingListController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetDossierNumberingListController.url(options),
    method: 'head',
})

export default GetDossierNumberingListController